import script from "./TableList.vue?vue&type=script&setup=true&lang=js"
export * from "./TableList.vue?vue&type=script&setup=true&lang=js"

import "./TableList.vue?vue&type=style&index=0&id=7f09b254&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f09b254"]])

export default __exports__